export default "__VITE_ASSET__BV9lDeh8__"